export default __webpack_public_path__ + "static/media/sweepstakesIcon.6780cca6.png";